import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { EmailOtpFlow } from "@/components/blocks/Login/EmailOtpFlow";
import { AuthPageLayout } from "@/components/layout/AuthPageLayout";
import { useAuthPageInteraction } from "@/hooks/useAuthPageInteraction";
import { getLoginRedirectFromLocation, getLoginRoute } from "@/common/routes.common";

export function LoginOtp() {
  const { t } = useTranslation();
  const { hasBeenInteracted, handleFormFocus } = useAuthPageInteraction();
  const { search } = useLocation();
  const passwordLoginRoute = getLoginRoute(getLoginRedirectFromLocation(search) ?? "/");

  return (
    <AuthPageLayout hasBeenInteracted={hasBeenInteracted}>
      <div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight">{t("auth.signIn")}</h2>
      </div>

      <div>
        <EmailOtpFlow onMouseDown={handleFormFocus} />
      </div>

      <div className="text-center">
        <Link to={passwordLoginRoute} className="text-sm hover:underline">
          {t("auth.loginWithPassword")}
        </Link>
      </div>
    </AuthPageLayout>
  );
}
